import React, { useState } from 'react';
import Card from '../card';
import reactImage from '../../images/cardpageimages/technicalcourse/reactimage.png'
import webDesignImage from '../../images/cardpageimages/technicalcourse/webdesingimage.jpg'
import mongodbImage  from '../../images/cardpageimages/technicalcourse/databaseMangaementImage.jpg'
import mernStackImage from '../../images/cardpageimages/technicalcourse/mernstackimage.jpg'
import meanStackImage from '../../images/cardpageimages/technicalcourse/meanstack.jpg'
import computerNetworkingImage  from '../../images/cardpageimages/technicalcourse/networking.jpg'
import fullStackImage from '../../images/cardpageimages/technicalcourse/fullstackwebdevelopment.jpg'
import coreJavaImage from '../../images/cardpageimages/technicalcourse/javaimage.jpg'
function HomeTechnicalCard() {
    const [showMore, setShowMore] = useState(false);

    const handleToggle = () => {
        setShowMore(!showMore);
    };

    return (
        <>
            <div className="container-fluid py-4 bg-gray">
                <div className="container">
                    <h2 className='text-center'>Explore Technical Courses</h2>
                    <div className="row d-md-flex d-block justify-content-evenly">
                        {/* First Row - Always Visible */}
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="React"
                            navigateurl="/react"
                            text="Master React for building dynamic user interfaces and single-page applications."
                           
                            image={reactImage}
                        />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="WEB DESIGN"
                            navigateurl="/webdesign"
                            text="Learn to craft beautiful and user-friendly websites that engage our visitors."
                            image={webDesignImage}
                        />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="FULL STACK DEVELOPMENT"
                            navigateurl="/webdevelopment"
                            text="Build dynamic web applications by mastering frontend and backend both skills."
                            image={fullStackImage}
                        />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="MERN STACK"
                            navigateurl="/mernstack"
                            text="Create powerful applications using MongoDB, Express.js, React, and Node.js."
                            image={mernStackImage}
                        />
                        </div>
                    </div>

                    {/* Second Row - Conditional Rendering */}
                    {showMore && (
                        <div className="row d-block d-md-flex justify-content-evenly mt-3">
                            <div className="col-md-3 mt-0 mt-sm-3">
                            <Card
                            title="Core Java"
                            navigateurl="/java"
                            text="Learn the fundamentals of Java for building robust and scalable applications."
                            image={coreJavaImage}
                        />
                            </div>
                            <div className="col-md-3 mt-0 mt-sm-3">
                            <Card
                            title="MEAN STACK"
                            navigateurl="/meanstack"
                            text="Some quick Develop full-stack applications with MongoDB, Express.js, Angular, and Node.js."
                            image={meanStackImage}
                        />
                            </div>
                            <div className="col-md-3 mt-0 mt-sm-3">
                            <Card
                            title="COMPUTER NETWORKING"
                            navigateurl="/networking"
                            text="Understand networking fundamentals to design and manage effective networks."
                           
                            image={computerNetworkingImage}
                        />
                            </div>
                            <div className="col-md-3 mt-0 mt-sm-3">
                            <Card
                            title="DATABASE MANAGEMENT"
                            navigateurl="/databasemanagement"
                            text="Gain skills in managing and optimizing databases for efficient data handling."
                            image={mongodbImage}
                        />
                            </div>
                        </div>
                    )}

                    {/* View More / View Less Button */}
                    <div className="text-end mt-3">
                        <button
                            onClick={handleToggle}
                            className="btn"
                            style={{ backgroundColor: 'black', color: 'white' }}
                        >
                            {showMore ? 'View Less' : 'View More'}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default HomeTechnicalCard;
